import { useState, useEffect } from 'react';
import { isBrowser } from 'ws-scripts/modules/environment';
import logger from 'ws-scripts/modules/logger';

/**
 * Hook to subscribe to location coordinates via ws-locations-data pubsub
 * Listens for location selection events from ws-location-control widget
 */
export const useLocationCoordinates = () => {
	const [coordinates, setCoordinates] = useState(null);

	useEffect(() => {
		if (!isBrowser) {
			return undefined;
		}

		// Subscribe to location selection events via ws-locations-data
		const locationsData = window?.DDC?.LocationsData;
		if (locationsData?.registerLocationSelectedNotification) {
			logger.debug(
				'[useLocationCoordinates] Subscribing to location-selected events'
			);

			const unsubscribe =
				locationsData.registerLocationSelectedNotification((data) => {
					if (data?.coordinates) {
						logger.debug(
							'[useLocationCoordinates] Received location via pubsub:',
							data
						);
						setCoordinates(data.coordinates);
					}
				});

			// Get current selected location coordinates if already set
			const currentCoordinates =
				locationsData.getSelectedLocationCoordinates();
			if (currentCoordinates) {
				logger.debug(
					'[useLocationCoordinates] Initial coordinates from LocationsData:',
					currentCoordinates
				);
				setCoordinates(currentCoordinates);
			}

			return unsubscribe;
		}
		logger.warn(
			'[useLocationCoordinates] LocationsData pubsub not available'
		);
		return undefined;
	}, []);

	return coordinates;
};
